import { createActions } from 'reduxsauce';

const { Creators, Types } = createActions({
    notificationsShowNotifications: [],
    notificationsHideNotifications: [],
    notificationsRequestNotifications: [],
    notificationsReceiveNotifications: ['notifications']
});

export { Creators, Types };